import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Modal, Button, Input, Form } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';

const { TextArea } = Input;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator } = form;
        return (
                <Modal
                    title="拒绝"
                    visible={this.modulesState.refuseM}
                    onOk={() => ModulesAction.refuseM()}
                    onCancel={() => ModulesAction.refuseM()}
                    width={441}
                    footer={[
                        <Button key="back" onClick={() => ModulesAction.refuseM()}>取消</Button>,
                        <Button key="submit" type="primary" onClick={this.submit} style={{ background: '#24B00D', borderColor: '#24B00D' }}>
                            确定
                        </Button>,
                    ]}
                >
                    <div className={css.refuseM}>
                        <Form >
                            <div className={css.title}>拒绝原因</div>
                            <FormItem>
                                {getFieldDecorator('reason', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            required: true,
                                            validator: this.checkLength,
                                            // pattern: {this.checkLength()},
                                            whitespace: true
                                        }
                                    ],
                                })(
                                    <TextArea 
                                        placeholder="请输入拒绝原因" 
                                        className={css.content} 
                                        style={{ resize: 'none'}}
                                        onChange={ModulesAction.checkLength}
                                    />
                                )}
                            </FormItem>
                            <span className={css.fontNumber}>{this.modulesState.refuseInputNum}/200</span>
                        </Form>
                    </div>
                </Modal>
        );
    }
    /**
     * 提交
     */
    private submit = () => {
        const { form: { validateFields } } = this.props;
        validateFields((err, value) => {
            if (!err) {
                ModulesAction.updataDocumentStatus(this.modulesState.refuseType, value.reason);
                ModulesAction.refuseM();
                this.props.form.resetFields();
            }
        });
    }
    /**
     *  检验输入长度
     * @param rule 
     * @param value 
     * @param callback 
     */
    private checkLength(rule: any, value: any, callback: any) {
        if (!value) {
            return callback('请输入拒绝理由');
        }
        return (value.length < 201 ? callback() : callback('不能超过200个字符'));
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/UI.RefuseM.tsx